import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class DoubleImg {
  constructor(el) {
    this.el = el
    this.imgs = el.querySelectorAll('.double-img--img')
    if (this.imgs.length) this.init()
  }

  init() {
    this.imgs.forEach(img => {
      gsap.fromTo(img,
        { clipPath: 'inset(0 100% 0 0)', scale: 1.08 },
        {
          clipPath: 'inset(0 0% 0 0)',
          scale: 1,
          duration: 1.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: img,
            start: 'top 80%',
            toggleActions: 'play none none none',
          }
        }
      )
    })
  }
}
